import api from './client';

export const fetchFeatureCatalog = () => api.get('/admin/feature_catalog');
